import useFetchUser from "./useFetchUser";

const useUser = () => {
  return useFetchUser({
    enabled: false
  }).data;
}

export default useUser;
